@if (changableRadius) {
  @if (["smallMapOtherJob", "largeMapOtherJob"].includes(mapId)) {
    <div class="mb-2 p-1">
      Notify me if guard is detected outside of this area.
    </div>
  }
  <div class="form-floating mb-2">
    <input
      class="form-control"
      list="numbers"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      [min]="minKm"
      placeholder="Geofence Radius (metres)"
      [max]="maxKm"
      [(ngModel)]="nearestKmValue"
      (focus)="nearestKmValue = ''"
      (input)="changeGeoFenceRadius()"
      (blur)="changeGeoFenceRadius()"
      pattern="\d*"
      [class.is-invalid]="nearestKmValue < minKm || nearestKmValue > maxKm"
    /><label for="inputAssignee"> Geofence Radius (metres)</label>
    <datalist id="numbers">
      @for (number of radiusRangeList; track number) {
        <option [value]="number">
          {{ number }}
        </option>
      }
    </datalist>
  </div>
}
<div
  [id]="mapId"
  class="map"
  style="position: relative; z-index: 0; max-height: 100%; max-width: 100%"
  [ngStyle]="mapId | misc: 'mapHeightCheck'"
></div>
<div class="small text-center text-secondary">
  {{ latLon?.lat }}, {{ latLon?.lon }}
</div>
